import React from 'react'

export default function Header({ title }: { title: string }) {
    return (
        <div className=" flex items-center justify-center mt-0.5">
            <div className=" flex-1 h-px bg-black mx-4" />
            <p className=" text-sm font-bold text-black whitespace-nowrap">
                {title}
            </p>
            <div className=" flex-1 h-px bg-black mx-4" />
        </div>
    )
}
